import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import {
  NumbersLayerProvider,
  useNumbersLayerContext,
} from 'pages/settings/pages/numbers/context/numbersLayerContext'
import styles from './styles.module.scss'

const NumbersProviderLayoutContent = observer(() => {
  const store = useNumbersLayerContext()

  if (store.loading) {
    return <SpinnerLoader ariaLabel={'numbersProviderLayout'} />
  }

  return (
    <FullPageWrapper className={styles.container}>
      <Outlet />
    </FullPageWrapper>
  )
})

export const NumbersProviderLayout = () => {
  return (
    <NumbersLayerProvider>
      <NumbersProviderLayoutContent />
    </NumbersLayerProvider>
  )
}
